<template>
  <div class="modal-container" :style="`backgroundImage: url('https://image.tmdb.org/t/p/original${this.serieDetail.backdrop_path}')`" @click="$router.back()">
    <modal-base>
      <div class="modal-body">
        <div class="modal-image">
          <img :src="`https://image.tmdb.org/t/p/original${this.serieDetail.poster_path}`" :alt="this.serieDetail.name">
        </div>
        <div class="modal-information">
          <div class="modal-title">
            <h2>{{ this.serieDetail.name }}</h2>
            <p v-if="this.serieDetail.tagline"><span class="modal-tagline">`` {{ this.serieDetail.tagline }} ``</span></p>
          </div>
          <div v-if="this.serieDetail.first_air_date && this.serieDetail.last_air_date" class="modal-episode">
            <div v-if="this.serieDetail.first_air_date" class="modal-episode-first">
              <h4>First air date</h4>
              <p>{{ this.serieDetail.first_air_date }}</p>
            </div>
            <div v-if="this.serieDetail.last_air_date" class="modal-episode-last">
              <h4>Last air date</h4>
              <p>{{ this.serieDetail.last_air_date }}</p>
            </div>
          </div>
          <div v-if="this.serieDetail.vote_count && this.serieDetail.vote_average" class="modal-vote">
            <div v-if="this.serieDetail.vote_count" class="modal-vote-count">
              <h4>Vote count</h4>
              <p>{{ this.serieDetail.vote_count }}</p>
            </div>
            <div v-if="this.serieDetail.vote_average" class="modal-vote-average">
              <h4>Vote average</h4>
              <p>{{ this.serieDetail.vote_average }}</p>
            </div>
          </div>
          <div class="modal-genres">
            <p v-for="genre in this.serieDetail.genres" :key="genre.name">{{ genre.name }}</p>
          </div>
        </div>
      </div>
    </modal-base>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        serieId: this.$route.params.id,
        serieDetail: {},
      };
    },
    created() {
      fetch(`https://api.themoviedb.org/3/tv/${this.serieId}?api_key=7e87347114ccb7e8746f73f84d249ab2&language=en-US`)
        .then(
          (response) => {
            response.json()
              .then(
                (data) => {
                  this.serieDetail = data;
                }
              )
          }
        )
    },
  };
</script>

<style scoped>
  .modal-container {
    height: calc(100vh - 68px);
    padding: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center;
  }

  .modal-body {
    height: 100%;
    width: 100%;
    display: flex;
  }

  .modal-image {
    display: flex;
  }

  img {
    height: 600px;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    object-fit: cover;
    object-position: 100% 0;
  }

  .modal-information {
    width: calc(100% - 400px);
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
  }

  .modal-title {
    margin-bottom: 16px;
  }

  h2 {
    width: 100%;
    margin-block-start: 0;
    margin-block-end: 0;
    text-transform: uppercase;
    text-align: center;
    font-size: 28px;
    border-bottom: 1px solid #0C1E7F;
  }

  .modal-tagline {
    margin-block-start: 0;
    margin-block-end: 0;
    font-style: italic;
  }

  h4 {
    margin-block-start: 0;
    margin-block-end: 0;
    font-size: 20px;
  }

  .modal-title, .modal-episode-first, .modal-episode-last, .modal-vote-count, .modal-vote-average {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .modal-episode, .modal-vote {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .modal-genres {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
  }

  @media (max-width: 799px) {
    .modal-container {
      height: auto;
    }

    .modal-body {
      flex-direction: column;
    }

    img {
      border-top-right-radius: 12px;
      border-bottom-left-radius: 0;
    }

    .modal-information {
      width: auto;
    }
  }

  @media (max-width: 499px) {
    .modal-container {
      height: calc(100vh - 68px);
      padding: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: cover;
      background-position: center;
    }

    .modal-body {
      flex-direction: column;
    }

    img {
      height: 100%;
      width: 300px;
      border-top-right-radius: 12px;
      border-bottom-left-radius: 0;
    }

    .modal-information {
      width: auto;
    }

    h2 {
      font-size: 16px;
    }

    h4 {
      font-size: 16px;
    }

    .modal-episode {
      margin-top: 12px;
    }

    .modal-title, .modal-episode-first, .modal-episode-last, .modal-vote-count, .modal-vote-average {
      font-size: 12px;
    }

    .modal-title p {
      margin-block-end: 0;
    }

    .modal-episode-first, .modal-vote-count {
      align-items: flex-start;
    }

    .modal-episode-last, .modal-vote-average {
      align-items: flex-end;
    }

    .modal-genres {
      font-size: 12px;
    }
  }
</style>
